'use client';

import * as React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { cn } from '@/utils/utils';

// Breadcrumb wrapper
const Breadcrumb = ({ children, className, ...props }) => {
  return (
    <nav className={cn('flex', className)} aria-label="Breadcrumb" {...props}>
      <ol className="inline-flex items-center space-x-1 md:space-x-3">
        {children}
      </ol>
    </nav>
  );
};

// Single breadcrumb item
const BreadcrumbItem = ({ children, className, ...props }) => {
  return (
    <li className={cn('inline-flex items-center', className)} {...props}>
      {children}
    </li>
  );
};

// Link inside breadcrumb
const BreadcrumbLink = React.forwardRef(
  ({ href, children, className, ...props }, ref) => {
    const isLast = props['aria-current'] === 'page';

    return (
      <div className="flex items-center">
        {!isLast && <ChevronRight className="h-4 w-4 mx-1 text-muted-foreground" />}
        <Link
          ref={ref}
          to={href}
          className={cn(
            'text-sm font-medium text-muted-foreground hover:text-foreground transition-colors',
            isLast && 'text-foreground cursor-default pointer-events-none',
            className
          )}
          {...props}
        >
          {children}
        </Link>
      </div>
    );
  }
);
BreadcrumbLink.displayName = 'BreadcrumbLink';

// List container for breadcrumb items
const BreadcrumbList = ({ children, className }) => (
  <ol className={cn('inline-flex items-center space-x-1 md:space-x-3', className)}>
    {children}
  </ol>
);

// Final breadcrumb item (non-link)
const BreadcrumbPage = ({ children, className }) => (
  <span className={cn('text-sm font-medium text-foreground', className)}>
    {children}
  </span>
);

// Separator icon (if needed standalone)
const BreadcrumbSeparator = ({ className }) => (
  <ChevronRight className={cn('h-4 w-4 text-muted-foreground', className)} />
);

export {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
};
